import React from "react";
import Home from "../components/view/Home";
import Courses from "../components/view/Courses";
import Contact from "../components/view/Contact";
import Bapushree from "../components/view/Bapushree";
import Maiyashree from "../components/view/Maiyashree";
import Mantra from "../components/view/Mantra";
import GSA from "../components/view/gsa";
import Trimurti from "../components/view/trimurti";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import BackToTop from "../components/common/BackToTop";
const Router = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/poojya-shri-punitachariji-maharaj" element={<Bapushree />} />
          <Route path="/poojya-Maiyashree-shailja-devi" element={<Maiyashree />} />
          
          <Route path="/hari-om-tatsat-jai-guru-datta" element={<Mantra />} />
          <Route path="/hari-om-tatsat-jay-guru-datta" element={<Mantra />} />
          <Route path="/hari-om-tatsat-jai-guru-datt" element={<Mantra />} />
          <Route path="/hari-om-tatsat-jay-guru-datt" element={<Mantra />} />

          <Route path="/girnar-sadhna-ashram" element={<GSA />} />
          <Route path="/trimurti-seva-ashram-rishikesh" element={<Trimurti />} />
        </Routes>
      </BrowserRouter>
      <BackToTop />
    </>
  );
};

export default Router;
